import { render, staticRenderFns } from "./info.vue?vue&type=template&id=40447ea4&scoped=true&"
var script = {}
import style0 from "./info.vue?vue&type=style&index=0&id=40447ea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40447ea4",
  null
  
)

export default component.exports